import { useTranslation } from 'react-i18next';
import { useUiStore } from '@/store/uiStore.ts';
import styles from './TeaseOverlay.module.css';

export function TeaseOverlay() {
  const { t } = useTranslation('landing');
  const kind = useUiStore(s => s.teaseOverlay);
  const close = useUiStore(s => s.setTeaseOverlay);

  if (!kind) return null;

  const title = kind === 'ai' ? t('teaseAiTitle') : t('teaseAudioTitle');
  const description = kind === 'ai' ? t('teaseAiDescription') : t('teaseAudioDescription');

  return (
    <div className={styles.backdrop} onClick={() => close(null)}>
      <div className={styles.dialog} onClick={e => e.stopPropagation()}>
        <button className={styles.closeBtn} onClick={() => close(null)} aria-label="Close">&#x2715;</button>
        <div className={styles.logoRow}>
          <img src="/previs-pro-logo.jpg" alt="Previs Pro" className={styles.logo} />
        </div>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>
        <p className={styles.tagline}>{t('teaseTagline')}</p>
      </div>
    </div>
  );
}
